module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-img"
  }, [(_vm.upstate == 'uploading') ? _c('div', [_c('el-button', {
    attrs: {
      "disabled": "",
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', [_vm._v("上传中...")]), _vm._v(" "), _c('i', {
    staticClass: "icon el-icon-loading"
  })])], 1) : _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/*,.pdf",
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "on-remove": _vm.handleRemove,
      "on-progress": _vm.handleProgress,
      "show-file-list": false,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [(!_vm.nowKey) ? _c('span', [_vm._v("点击上传")]) : _c('span', [_vm._v("更新")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传 jpg/jpeg/png/pdf 文件，且不超过 2M")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-153e099b"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/enterpriseMent/src/firmUpload.vue
// module id = 1418
// module chunks = 1